import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { TextFormat, Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './product-process.reducer';

export const ProductProcessDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const productProcessEntity = useAppSelector(state => state.productProcess.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="productProcessDetailsHeading">
          <Translate contentKey="crawlerBackendApp.productProcess.detail.title">ProductProcess</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{productProcessEntity.id}</dd>
          <dt>
            <span id="processType">
              <Translate contentKey="crawlerBackendApp.productProcess.processType">Process Type</Translate>
            </span>
          </dt>
          <dd>{productProcessEntity.processType}</dd>
          <dt>
            <span id="stepType">
              <Translate contentKey="crawlerBackendApp.productProcess.stepType">Step Type</Translate>
            </span>
          </dt>
          <dd>{productProcessEntity.stepType}</dd>
          <dt>
            <span id="stepStatus">
              <Translate contentKey="crawlerBackendApp.productProcess.stepStatus">Step Status</Translate>
            </span>
          </dt>
          <dd>{productProcessEntity.stepStatus}</dd>
          <dt>
            <span id="retryCount">
              <Translate contentKey="crawlerBackendApp.productProcess.retryCount">Retry Count</Translate>
            </span>
          </dt>
          <dd>{productProcessEntity.retryCount}</dd>
          <dt>
            <span id="payloadIn">
              <Translate contentKey="crawlerBackendApp.productProcess.payloadIn">Payload In</Translate>
            </span>
          </dt>
          <dd>{productProcessEntity.payloadIn}</dd>
          <dt>
            <span id="payloadOut">
              <Translate contentKey="crawlerBackendApp.productProcess.payloadOut">Payload Out</Translate>
            </span>
          </dt>
          <dd>{productProcessEntity.payloadOut}</dd>
          <dt>
            <span id="coolingOffEnd">
              <Translate contentKey="crawlerBackendApp.productProcess.coolingOffEnd">Cooling Off End</Translate>
            </span>
          </dt>
          <dd>
            {productProcessEntity.coolingOffEnd ? (
              <TextFormat value={productProcessEntity.coolingOffEnd} type="date" format={APP_LOCAL_DATE_FORMAT} />
            ) : null}
          </dd>
          <dt>
            <span id="offerExpirationDate">
              <Translate contentKey="crawlerBackendApp.productProcess.offerExpirationDate">
                Offer Expiration Date
              </Translate>
            </span>
          </dt>
          <dd>
            {productProcessEntity.offerExpirationDate ? (
              <TextFormat value={productProcessEntity.offerExpirationDate} type="date" format={APP_LOCAL_DATE_FORMAT} />
            ) : null}
          </dd>
          <dt>
            <span id="mandateSignedDate">
              <Translate contentKey="crawlerBackendApp.productProcess.mandateSignedDate">Mandate Signed Date</Translate>
            </span>
          </dt>
          <dd>
            {productProcessEntity.mandateSignedDate ? (
              <TextFormat value={productProcessEntity.mandateSignedDate} type="date" format={APP_LOCAL_DATE_FORMAT} />
            ) : null}
          </dd>
          <dt>
            <span id="desiredDate">
              <Translate contentKey="crawlerBackendApp.productProcess.desiredDate">Desired Date</Translate>
            </span>
          </dt>
          <dd>
            {productProcessEntity.desiredDate ? (
              <TextFormat value={productProcessEntity.desiredDate} type="date" format={APP_LOCAL_DATE_FORMAT} />
            ) : null}
          </dd>
          <dt>
            <span id="actualStartDate">
              <Translate contentKey="crawlerBackendApp.productProcess.actualStartDate">Actual Start Date</Translate>
            </span>
          </dt>
          <dd>
            {productProcessEntity.actualStartDate ? (
              <TextFormat value={productProcessEntity.actualStartDate} type="date" format={APP_LOCAL_DATE_FORMAT} />
            ) : null}
          </dd>
          <dt>
            <span id="transactionId">
              <Translate contentKey="crawlerBackendApp.productProcess.transactionId">Transaction Id</Translate>
            </span>
          </dt>
          <dd>{productProcessEntity.transactionId}</dd>
          <dt>
            <span id="waiveCoolingOffRight">
              <Translate contentKey="crawlerBackendApp.productProcess.waiveCoolingOffRight">
                Waive Cooling Off Right
              </Translate>
            </span>
          </dt>
          <dd>{productProcessEntity.waiveCoolingOffRight ? 'true' : 'false'}</dd>
          <dt>
            <span id="depositRequired">
              <Translate contentKey="crawlerBackendApp.productProcess.depositRequired">Deposit Required</Translate>
            </span>
          </dt>
          <dd>{productProcessEntity.depositRequired ? 'true' : 'false'}</dd>
          <dt>
            <span id="deposit">
              <Translate contentKey="crawlerBackendApp.productProcess.deposit">Deposit</Translate>
            </span>
          </dt>
          <dd>{productProcessEntity.deposit ? 'true' : 'false'}</dd>
          <dt>
            <span id="createdAt">
              <Translate contentKey="crawlerBackendApp.productProcess.createdAt">Created At</Translate>
            </span>
          </dt>
          <dd>
            {productProcessEntity.createdAt ? (
              <TextFormat value={productProcessEntity.createdAt} type="date" format={APP_DATE_FORMAT} />
            ) : null}
          </dd>
          <dt>
            <span id="updatedAt">
              <Translate contentKey="crawlerBackendApp.productProcess.updatedAt">Updated At</Translate>
            </span>
          </dt>
          <dd>
            {productProcessEntity.updatedAt ? (
              <TextFormat value={productProcessEntity.updatedAt} type="date" format={APP_DATE_FORMAT} />
            ) : null}
          </dd>
          <dt>
            <Translate contentKey="crawlerBackendApp.productProcess.product">Product</Translate>
          </dt>
          <dd>{productProcessEntity.product ? productProcessEntity.product.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/product-process" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/product-process/${productProcessEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default ProductProcessDetail;
